export const en = {
  appName: "Spot",
  tagline: "Your time, perfectly planned.",
  nav: {
    home: "Plan",
    explore: "Reserve",
    plans: "My Plans",
    profile: "Profile",
  },
  actions: {
    continue: "Continue",
    retry: "Try again",
    reserve: "Request bookings",
    signIn: "Sign in to unlock",
    replace: "Replace place",
    remove: "Remove stage",
    save: "Save changes",
    directions: "Get directions",
    refreshWeather: "Refresh weather",
  },
  home: {
    eyebrow: "PLAN YOUR TIME",
    title: "What do you want to do today?",
    step: "Step",
    of: "of",
    stepStart: "Plan essentials",
    stepDetails: "Make it yours",
    next: "Add optional preferences",
    back: "Back to plan essentials",
    skipPreferences: "Skip preferences and create plans",
    optionalTitle: "This step is optional",
    optionalBody:
      "Choose a duration or mood if you want to shape the suggestions—or create your plans as they are.",
    location: "Starting point",
    city: "Choose a city or town",
    currentLocation: "Start from where I am",
    originHint:
      "Your exact position becomes the route origin only after you choose this.",
    locationDenied: "Location access is off. Choose a city or town instead.",
    date: "Date",
    time: "Start time",
    timeThemeHint: "The look changes automatically for day and night plans.",
    duration: "Time available",
    groupSize: "Group size",
    people: "People",
    optional: "Optional",
    budget: "Budget per person",
    flexible: "Flexible",
    budgetHint: "Slide to set an estimated maximum per person.",
    vibe: "Vibe / mood",
    generate: "Create my plans",
    surprise: "Surprise Me",
    surpriseTitle: "Let Spot choose",
    surpriseBody:
      "Spot will choose activities while respecting your starting point, date, time, duration, group and budget.",
    generateError:
      "We couldn’t create plans. Check your choices and try again.",
  },
  durations: {
    one_to_two_hours: "1–2 hours",
    three_to_four_hours: "3–4 hours",
    half_day: "Half day",
    full_day: "Full day",
  },
  interests: {
    romantic: "Romantic",
    chill_relaxed: "Chill and relaxed",
    party_dancing: "Party and dancing",
    upscale_luxurious: "Upscale and luxurious",
    casual_friends: "Casual with friends",
    live_music: "Live music",
    food_focused: "Food-focused",
    culture: "Culture",
    outdoor: "Outdoor",
    adventure: "Adventure",
    wellness: "Wellness",
    shopping: "Shopping",
    family_friendly: "Family-friendly",
  },
  categories: {
    food_dining: "Food and dining",
    coffee_dessert: "Coffee and dessert",
    entertainment: "Entertainment",
    culture_sightseeing: "Culture and sightseeing",
    outdoor_nature: "Outdoor and nature",
    adventure_games: "Adventure and games",
    wellness: "Wellness",
    shopping: "Shopping",
    family_activities: "Family activities",
    nightlife: "Nightlife",
  },
  plans: {
    title: "Your plans",
    eyebrow: "5 CURATED OPTIONS",
    intro: "Each plan is fitted to your time, group and preferences.",
    stops: "stages",
    duration: "total",
    cost: "estimated per person",
    driving: "estimated driving",
    weatherUnavailable:
      "Forecast not available yet. You can refresh closer to the date.",
    weatherStale: "Weather context may be out of date.",
    fromOrigin: "From your starting point",
    fromPrevious: "From previous stage",
    estimated: "Estimated",
    unlockTitle: "The rest of your plan is ready",
    unlockBody:
      "Sign in to reveal every stage and keep this exact plan. We won’t regenerate it.",
    reserveNote:
      "Only request-to-book stages are sent to venues. Walk-in activities stay in your itinerary.",
  },
  booking: {
    walk_in: "Walk-in",
    no_booking_required: "No booking required",
    request_to_book: "Request to book",
    instant_book: "Instant booking",
    external_booking: "External booking",
    request_pending: "Request pending",
    accepted_deposit_required: "Accepted—deposit required",
    confirmed: "Confirmed",
    rejected: "Rejected",
    replacement_required: "Replacement required",
    expired: "Expired",
    cancelled: "Cancelled",
  },
  weather: {
    suitable: "Suitable for forecast",
    caution: "Weather caution",
    unknown: "Forecast unavailable",
  },
  states: {
    offline: "You’re offline. Showing saved information.",
    empty: "Nothing here yet.",
    stale: "This may be out of date.",
    loading: "Building your plans…",
  },
  auth: {
    title: "Unlock your complete plan",
    mobile: "Mobile number",
    dob: "Date of birth",
    adult: "I confirm I am 18 or older",
    send: "Send verification code",
    code: "6-digit code",
    verify: "Verify and continue",
    google: "Continue with Google",
  },
  explore: {
    eyebrow: "FIND & BOOK",
    title: "Reserve a place",
    intro:
      "Browse places, check their booking mode and send a request where Spot booking is supported.",
    search: "Search places or areas",
    allTypes: "All activities",
    anyPrice: "Any price",
    openNow: "Open now",
    list: "List",
    map: "Map",
  },
  directBooking: {
    eyebrow: "RESERVATION REQUEST",
    title: "Request a booking",
    date: "Date",
    time: "Preferred time",
    partySize: "Group size",
    leadGuest: "Lead guest name",
    verifiedMobile: "Verified mobile number",
    occasion: "Occasion (optional)",
    requests: "Special requests (optional)",
    submit: "Send booking request",
    pendingTitle: "Request sent",
    pendingBody:
      "The place has not accepted yet. You’ll receive an update when it responds.",
    independent:
      "This is a request, not a confirmed reservation. If accepted, any required deposit must be paid before confirmation.",
    signInTitle: "Sign in to request this booking",
    signInBody:
      "A verified mobile number is required before Spot can contact the place.",
    notRequired: "No Spot reservation is required for this place.",
    unavailable:
      "Direct booking is not supported by the current server contract yet.",
  },
  reservations: {
    title: "Plans & bookings",
    eyebrow: "YOUR TIME",
    active: "Active booking requests",
    saved: "Generated and saved",
    independent: "Places respond independently",
    independentBody:
      "Spot sends requests only for bookable stages. Walk-in and no-booking stages remain part of your plan without being marked pending.",
  },
  profile: {
    eyebrow: "YOUR ACCOUNT",
    title: "Profile",
    guestTitle: "Make Spot yours",
    guestBody:
      "Sign in to manage your details, preferences and booking privacy.",
    signIn: "Sign in or register",
    account: "Account",
    personal: "Personal & contact details",
    whish: "Saved Whish references",
    none: "None",
    sessions: "Sessions & devices",
    thisDevice: "This device",
    preferences: "Preferences",
    notifications: "Notifications",
    pushOn: "Push on",
    privacy: "Privacy requests",
    language: "Language",
    english: "English",
    paymentPrivacy: "Payment privacy",
    paymentPrivacyBody:
      "Spot never stores Whish PINs, passwords, card data or raw payment credentials.",
    logout: "Log out",
    delete: "Delete account",
    deleteConfirm:
      "Delete your Spot account and anonymise your personal details? This cannot be undone.",
  },
} as const;
export type Messages = typeof en;
